import { dateFormatter } from 'helpers/dateFormatter';
import { getUSNumberFormat } from 'helpers/formatData';
import ProgressStatus from 'components/ProgressStatus/ProgressStatus';

export const propertyColumns = [
  { Header: 'Property Name', accessor: 'name', align: 'left', disableSortBy: true, },
  { Header: 'Listing Date', accessor: 'listingDate', align: 'right', disableSortBy: true, },
  { Header: 'Funded Percentage', accessor: 'fundedPercentage', align: 'right', disableSortBy: true, },
  { Header: 'Investors', accessor: 'noOfInvestors', align: 'right', disableSortBy: true, },
];

export const propertyRows = (properties) => {
  return properties?.map((rowData) => {
    return {
      name: rowData?.name,
      listingDate: dateFormatter(rowData?.listingDate),
      noOfInvestors: getUSNumberFormat(rowData?.noOfInvestors),
      fundedPercentage: (
        <ProgressStatus value={rowData?.fundedPercentage || 0} />
      ),
    };
  });
};
